import { ref, watch } from 'vue'
import type { INewsModel } from '../types/news'

interface INewsListingMeta {
	last_page?: number
	lastPage?: number
}

interface INewsListingResponse {
	data?: Partial<INewsModel>[]
	meta?: INewsListingMeta
}

export type TNewsListingFetcher = (page: number, perPage: number) => Promise<INewsListingResponse>

export const useNewsListing = (fetcher: TNewsListingFetcher, initialPage = 1, perPage = 12) => {
	const fetchedNews = ref<Partial<INewsModel>[]>()
	const loader = ref(false)
	const currentPage = ref(initialPage)
	const maxPage = ref(1)

	const fetchNews = async () => {
		loader.value = true
		try {
			const { data, meta } = await fetcher(currentPage.value, perPage)

			if (meta) maxPage.value = meta.last_page ?? meta.lastPage ?? 1
			if (data) fetchedNews.value = data
		} catch (error) {
			logger.log(error)
		}
		loader.value = false
	}

	watch(currentPage, (newValue) => {
		if (newValue) fetchNews()
	})

	return { fetchedNews, loader, currentPage, maxPage, fetchNews }
}
